import { call, put, delay, select } from 'redux-saga/effects';
import qs from 'query-string';
import { API as awsAPI, Storage } from 'aws-amplify';
import { saveAs } from 'file-saver';

const defaultTry = 2;

export const getQuerystring = ({ querystring }) => querystring;

const EXCLUDE_QUERY_STRING = ['/users/'];
export function* API(method, apiName, basePath, payload = {}, tries = defaultTry) {
  yield put({ type: 'LOADING_STARTED' });
  const querystring = yield select(getQuerystring);
  let query = qs.stringify(querystring);

  if (EXCLUDE_QUERY_STRING.find((str) => basePath.includes(str))) {
    query = '';
  }

  let path = basePath;
  if (path.includes('?') && query) {
    path = `${basePath}&${query}`;
  } else if (!path.includes('?') && query) {
    path = `${basePath}?${query}`;
  }
  let response = {};

  try {
    response = yield call([awsAPI, awsAPI[method]], apiName, path, payload);
  } catch (e) {
    yield put({ type: 'LOADING_STOPPED' });

    if (!tries) throw e;
    yield delay(150 * Math.random() + 1);
    response = yield call(API, method, apiName, basePath, payload, tries - 1);
  }

  try {
    if (response) {
      if (response.uploaded && response.type === 'csv') {
        const s3Response = yield call([Storage, Storage.get], response.path, {
          download: true,
        });
        if (s3Response.ContentType === 'binary/octet-stream') {
          saveAs(s3Response.Body, 'parcels.csv');
        } else {
          const blob = new Blob(
            [new TextDecoder('utf-8').decode(s3Response.Body)],
            { type: 'text/plain;charset=utf-8' },
          );
          saveAs(blob, 'parcels.csv');
        }
      } else if (response.uploaded && response.type === 'zip') {
        const s3Response = yield call([Storage, Storage.get], response.path, {
          download: true,
        });
        const blob = new Blob([s3Response.Body], { type: 'application/zip' });
        saveAs(blob, 'parcels.zip');
      }
    } else if (response.uploaded) {
      const s3Response = yield call([Storage, Storage.get], response.path, {
        download: true,
      });
      response = JSON.parse(s3Response.Body.toString());
    }
  } catch (e) {
    console.error('API request failed', { method, apiName, path });
    console.error(e);
  }

  yield put({ type: 'LOADING_STOPPED' });
  return response;
}
